// extracted by mini-css-extract-plugin
export default {"text":"Skeleton_text__IvNGk","meta":"Skeleton_meta__PGO8b"};